module.exports = __webpack_public_path__ + "img/1f981.afd90bd.svg";